
import { InputNumber } from 'antd';

const AntInputNumber = ({ placeholder, label, onChange, value }) => {

    return (
        <InputNumber placeholder={placeholder} value={value} addonBefore={label} onChange={onChange} />
    );
};
export default AntInputNumber;
